import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FrontEndService} from "../../services/front-end.service";
import {ModalDismissReasons, NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {DataService} from "../../services/data.service";

@Component({
  selector: 'app-country-modal',
  templateUrl: './country-modal.component.html',
  styleUrls: ['./country-modal.component.scss']
})
export class CountryModalComponent implements OnInit {

  searchCountry = "";
  countries = [];
  modalRef: NgbModalRef;
  closeResult: any;

  @ViewChild("countryModalContent") private countryModalContent: ElementRef;

  constructor(
    private modalService: NgbModal,
    private frontEndService: FrontEndService,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.countries = this.dataService.countriesList;
  }

  selectCountry(countryName, countryCode, countryDialCode) {
    this.dataService.selectedCountryName = countryName;
    this.dataService.selectCountryCode = countryCode;
    this.dataService.selectCountryDial = countryDialCode;
    this.dataService.countryPlaceholder = false;
    if (localStorage.getItem('user') !== null) {
      if(this.dataService.selectCountryDial.slice(1) !==  this.dataService.oldCountry) {
        this.dataService.userDetails["profile"].mobileVerified = false;
      } 
      
    }
    this.closeModal();
  }

  private filterCountries = () => {
    setTimeout(() => {
      // this.logService.printLog("Searched country - ", this.searchCountry);
      // this.logService.printLog("Countries filtered list - ", this.countries);
      if (this.searchCountry !== "") {
        this.countries = this.dataService.countriesList.filter(country =>
          country.name.toLowerCase().startsWith(this.searchCountry.toLowerCase())
        );
      } else {
        this.countries = this.dataService.countriesList;
      }
    }, 200);
  };

  closeModal() {
    // this.logService.printLog("Closing modal");
    this.modalRef.close('Logged in');
    // document.querySelector('body').classList.add('modal-open');
  }

  openModal() {
    this.modalRef = this.modalService.open(this.countryModalContent);
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/country-modal/country-modal.component.ts